module.exports = __webpack_public_path__ + "static/media/playstore@2x.6df05bc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/playstore@2x.png
// module id = 746
// module chunks = 0